import $ from 'jquery';
import 'slick-carousel';

$(function() {
    $('.activities-carousel').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 20000,
        draggable: false,
        pauseOnHover: false,
        pauseOnFocus: false,
        swipe: false,
        cssEase: 'linear',
        arrows: false,
        rows: 0,
    });

    $('.testimonies-carousel').slick({
        appendArrows: '.slick-arrow-wrapper',
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        fade: true,
        speed: 300,
        cssEase: 'linear',
        autoplay: true,
        autoplaySpeed: 7000,
        rows: 0,
    });
});
